module.exports = __webpack_public_path__ + "img/icon_display.122245f7.svg";